import { render, staticRenderFns } from "./DataDetail.vue?vue&type=template&id=6437a53c&scoped=true"
import script from "./DataDetail.vue?vue&type=script&lang=js"
export * from "./DataDetail.vue?vue&type=script&lang=js"
import style0 from "./DataDetail.vue?vue&type=style&index=0&id=6437a53c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6437a53c",
  null
  
)

export default component.exports